import lang from '../lang';
import Vue from 'vue';


Vue.filter('__trans', (value, convert = 'en') => {

  if (value.length === 0) {
    return value;
  }
  const text = value.replace(/ /ig, '_').toLowerCase(); // some_example

  return lang[text][convert]
});


// WEBPACK FOOTER //
// ./src/utils/translater.js